import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { getOrganizationMembers, ThunkDispatch } from 'store';
import { useDispatch } from 'react-redux';
import { useMe, useCurrentClient, useCurrentOrganizationId } from 'queries';
import { useLocale } from '@app/i18n';

import { RedirectFromDeprecated } from '../Anonymous/RedirectFromDeprecated';

export const Dashboard = () => {
  const dispatch = useDispatch<ThunkDispatch>();

  const { data: account } = useMe();
  const { data: client } = useCurrentClient();

  useLocale(client?.account.locale);
  const orgaId = useCurrentOrganizationId();

  useEffect(() => {
    if (!orgaId) {
      return;
    }
    dispatch(getOrganizationMembers(orgaId)).catch(() => {});
  }, [orgaId, dispatch]);

  if (account && !account.roles.includes('CLIENT')) {
    return <RedirectFromDeprecated />;
  }

  return <Outlet />;
};
